var version = {
    "name":      "dativery",
    "buildDateCode": "20261104-152832",
    "buildDate": "Wed Nov 04 2026 15:28:32 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261104-152832",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;